import { Component, Input, OnChanges } from '@angular/core';
import { EChartsOption } from 'echarts';
import {
	THEME_COLOR_BLUE,
	THEME_COLOR_GREEN,
	THEME_COLOR_MAIN,
	THEME_COLOR_PINK,
	THEME_COLOR_VIOLET
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { DateUtils } from 'src/app/shared/utils/date-utils';

@Component({
	selector: 'app-working-time',
	templateUrl: './working-time.component.html',
	styleUrls: ['./working-time.component.scss']
})
export class WorkingTimeComponent implements OnChanges {
	boxPlotTitle = 'Dispersion';
	@Input() globalStats: any;
	@Input() lsfStats: any;
	@Input() lpcStats: any;
	@Input() pdnStats: any;
	@Input() oralStats: any;
	option: EChartsOption;
	@Input() stats: any;
	@Input() categorie = 1;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;

	constructor(protected dateutil: DateUtils, private facade: FacadeService) {
		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();
	}

	ngOnChanges(changes: any) {
		if (isNaN(this.globalStats)) {
			try {
				this.updatePieChart();
			} catch (error) {}
		}
	}

	updatePieChart(): void {
		if (
			this.isSESSAD &&
			isNaN(this.lpcStats) &&
			isNaN(this.lsfStats) &&
			isNaN(this.pdnStats) &&
			isNaN(this.oralStats)
		) {
			this.option = {
				title: {
					text: 'Par compétence',
					left: 'center',
					textStyle: { color: THEME_COLOR_MAIN },
					subtextStyle: { color: THEME_COLOR_MAIN }
				},
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b} ({d}%)'
				},
				series: [
					{
						name: 'Temps de travail',
						type: 'pie',
						radius: '50%',
						data: [
							{
								value: this.dateutil.convertStringHoursToNumber(
									this.lpcStats.beanParametreStatistiqueTempsTotal.tempsMoyenne
								),
								name: 'LPC',
								itemStyle: { color: THEME_COLOR_BLUE }
							},
							{
								value: this.dateutil.convertStringHoursToNumber(
									this.lsfStats.beanParametreStatistiqueTempsTotal.tempsMoyenne
								),
								name: 'LSF',
								itemStyle: { color: THEME_COLOR_GREEN }
							},
							{
								value: this.dateutil.convertStringHoursToNumber(
									this.pdnStats.beanParametreStatistiqueTempsTotal.tempsMoyenne
								),
								name: 'PDN',
								itemStyle: { color: THEME_COLOR_PINK }
							},
							{
								value: this.dateutil.convertStringHoursToNumber(
									this.oralStats.beanParametreStatistiqueTempsTotal.tempsMoyenne
								),
								name: 'Oral',
								itemStyle: { color: THEME_COLOR_VIOLET }
							}
						],
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}
				]
			};
		} else if (this.isSAAD) {
			this.option = {
				title: {
					text: 'Par compétence',
					left: 'center',
					textStyle: { color: THEME_COLOR_MAIN },
					subtextStyle: { color: THEME_COLOR_MAIN }
				},
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b} ({d}%)'
				},
				series: [
					{
						name: 'Temps de travail',
						type: 'pie',
						radius: '50%',
						data: [
							{
								value: this.dateutil.convertStringHoursToNumber(
									this.globalStats.beanParametreStatistiqueTempsTotal
										.tempsMoyenne
								),
								name: 'Aide à domicile',
								itemStyle: { color: THEME_COLOR_BLUE }
							}
						],
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}
				]
			};
		}
	}
}
